import { trigger, state, style, animate, transition } from '@angular/animations';

export const expandCollpaseAnimation = trigger('expandCollapseSidebar', [
    state('expanded', style({ minWidth: '220px' })),
    state('collapsed', style({ minWidth: '64px' })),
    transition('expanded <=> collapsed', animate('200ms'))
]);
